import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export const ViewTracker = () => {
  useEffect(() => {
    const trackView = async () => {
      console.log("Global ViewTracker: tracking /links view...");
      try {
        const { error } = await supabase.from('link_page_views').insert({
          user_agent: navigator.userAgent,
          referrer: document.referrer,
        });
        if (error) {
          console.error("Global ViewTracker error:", error);
        } else {
          console.log("Global ViewTracker: tracked successfully!");
        }
      } catch (err) {
        console.error("Global ViewTracker unexpected error:", err);
      }
    };

    if (window.location.pathname === "/links") {
      trackView();
    }
  }, []);

  return null;
};
